import React from 'react'

import ContactUsPage from './contact-us-page'

export default function ContactUs() {
    return <ContactUsPage />
}